import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { PasswordDontMatch } from '@config/messages.config';
import { RegexPassword } from '@config/regex.config';
import { ModalSuccessService } from '@modules';
import { Subscription } from 'rxjs';
import { ChangePasswordModel } from '../../models/auth.model';
import { ToastService } from '../toast/toast.service';
import { ChangePasswordService } from './change-password.service';
import { Location } from '@angular/common';
import { getItemSession } from '../../utilities/storage.utilities';

@Component({
  selector: 'ggi-journey-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
})
export class ChangePasswordComponent implements OnInit, OnDestroy {
  public form: FormGroup;

  public showCancel = false;

  public actualText = false;
  public newText = false;
  public confirmText = false;
  public username = '';

  private subscriptions: Subscription[] = [];

  constructor(
    private readonly fb: FormBuilder,
    private readonly toast: ToastService,
    private readonly service: ChangePasswordService,
    private readonly modalSuccessService: ModalSuccessService,
    private readonly router: Router,
    private readonly location: Location
  ) {}

  ngOnInit(): void {
    this.username = getItemSession('user', 'username');
    this.form = this.generateForm();
    this.getModalSuccessStatus();
  }

  ngOnDestroy(): void {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }

  /**
   * GEt moda success status
   */
  public getModalSuccessStatus(): void {
    this.subscriptions.push(
      this.modalSuccessService.modal.subscribe((res: boolean) => {
        if (!res) {
          this.router.navigateByUrl('/iniciar-sesion');
        }
      })
    );
  }

  /**
   * Generate change password form
   */
  public generateForm(): FormGroup {
    return this.fb.group({
      actualPassword: ['', [Validators.required]],
      newPassword: [
        '',
        [Validators.required, Validators.pattern(RegexPassword)],
      ],
      confirmPassword: ['', [Validators.required]],
    });
  }

  /**
   * Change input type (text, password)
   */
  public changeInputType(type: string): void {
    switch (type) {
      case 'actual': {
        this.actualText = !this.actualText;
        break;
      }
      case 'new': {
        this.newText = !this.newText;
        break;
      }
      case 'confirm': {
        this.confirmText = !this.confirmText;
      }
    }
  }

  /**
   * Change current password
   */
  public submitChangePassword(): void {
    const { actualPassword, newPassword, confirmPassword } = this.form.value;

    if (this.form.invalid || actualPassword === newPassword) {
      this.form.markAsTouched();
      this.toast.error();
      return;
    }

    if (newPassword !== confirmPassword) {
      this.toast.error(PasswordDontMatch);
    } else {
      const password: ChangePasswordModel = {
        actualPassword,
        newPassword,
      };
      this.subscriptions.push(
        this.service.changeUserPassword(password).subscribe()
      );
    }
  }

  /**
   * Show cancel modal
   */
  public cancel(): void {
    if (this.form.dirty) {
      this.showCancel = true;
    } else {
      this.back();
    }
  }

  /**
   * Back to previous page
   */
  public back(): void {
    this.location.back();
  }
}
